"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "array",
  "items": {
    "type": "object",
    "properties": {
      "title": {
        "type": "string"
      },
      "description": {
        "type": "string"
      },
      "checked": {
        "type": "boolean"
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;